<template>
    <component :is="component" v-if="component" :class="iconClass" />
    <span v-else :class="iconClass"></span>
</template>

<script>
/**
 * Icon component. Will load the icon dynamically.
 *
 * @version 4.0.0
 * @example ./examples/Icon.md
 */
export default {
    name: 'DkIcon',
    props: {
        /**
         * The icon name. Check v4/assets/svg/icons for availability.
         */
        name: {
            type: String,
            required: true,
        },
        /**
         * Icon size. Available sizes: `xs`, `s`, `m`, `l`
         */
        size: {
            type: String,
            default: null,
        },
        /**
         * Icon color.
         */
        color: {
            type: String,
            default: null,
        },
        /**
         * Whether the icon is spinning. For loaders.
         */
        isSpinning: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            component: null,
        };
    },
    computed: {
        iconClass() {
            return {
                'dk-icon': true,
                [`dk-icon--${this.size}`]: this.size,
                [`tw-text-${this.color}`]: this.color,
                'dk-icon--spin': this.isSpinning,
            };
        },
    },
    watch: {
        name(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            this.handleIconLoad();
        },
    },
    created() {
        this.handleIconLoad();
    },
    methods: {
        loadIconComponent(iconName) {
            return import(/* webpackChunkName: "icon-[request]" */ `@/assets/svg/icons/${iconName}.svg`);
        },
        handleIconLoad() {
            if (!this.name) {
                return;
            }

            const iconComponent = this.loadIconComponent(this.name);

            iconComponent
                .then(() => {
                    this.component = () => iconComponent;
                })
                .catch(() => {
                    this.component = () => this.loadIconComponent('generic-drivek-symbol');
                });
        },
    },
};
</script>
